<template>
  <div class="container py-4">
    <h3 class="mb-4">Communication Logs</h3>

    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>Initiating User</th>
          <th>Send Mode</th>
          <th>Schedule Time</th>
          <th>Channels</th>
          <th>Recipients</th>
          <th>Phone Count</th>
          <th>Email Count</th>
          <th>Message / Subject</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(log, index) in logs" :key="log.id">
          <td>{{ index + 1 }}</td>
          <td>{{ log.user ? log.user.name : "N/A" }}</td>
          <td>{{ log.send_mode }}</td>
          <td>{{ formatDate(log.schedule_time) }}</td>
          <td>{{ log.channels.join(", ") }}</td>
          <td>{{ log.recipients.join(", ") }}</td>
          <td>{{ log.phone_count }}</td>
          <td>{{ log.email_count }}</td>
          <td>{{ log.message || log.email_subject }}</td>
        </tr>
      </tbody>
    </table>

    <div v-if="loading" class="text-center mt-3">Loading...</div>
  </div>
</template>

<script>
// import { generalApiRequest } from "../../../api/apiIndex";
import { generalApiRequest } from "../api/apiIndex";

export default {
  name: "CommunicationLogs",
  data() {
    return {
      logs: [],
      loading: false,
    };
  },
  methods: {
    async fetchLogs() {
      try {
        this.loading = true;
        const response = await generalApiRequest(
          "communications/logs",
          "GET",
          {},
          1
        );
        this.logs = response.data || response;
      } catch (error) {
        console.error("Failed to fetch logs:", error);
      } finally {
        this.loading = false;
      }
    },
    formatDate(datetime) {
      if (!datetime) return "";
      const d = new Date(datetime);
      return d.toLocaleString();
    },
  },
  mounted() {
    this.fetchLogs();
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 10px;
  text-align: left;
}

th {
  background-color: #f8f9fa;
}
</style>
